import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();

$(function() {
	const sliderFeatured = {

		init: function() {
			this.sliderInit();
		},

		sliderInit: function() {
			$('.js-featured-slider__slider').each(function() {
				const $slider = $(this);
				const $wrapper = $slider.closest('.featured-slider');
				const $prevArrow = $wrapper.find('.featured-slider__arrow--prev');
				const $nextArrow = $wrapper.find('.featured-slider__arrow--next');
				const $numbers = $wrapper.find('.featured-slider__numbers');

				const sliderConfig = {
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: false,
					arrows: true,
					dots: false,
					infinite: false,
					prevArrow: $prevArrow,
					nextArrow: $nextArrow,
					responsive: [
						{
							breakpoint: 991,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				};

				$slider.on('init', function(event, slick) {
					const total = slick.slideCount;
					const current = slick.currentSlide + 1;
					$numbers.text(`${current} / ${total}`);
				});

				$slider.on('afterChange', function(event, slick, currentSlide) {
					const total = slick.slideCount;
					const current = currentSlide + 1;
					$numbers.text(`${current} / ${total}`);
				});

				sliders.initializeSlider($slider, sliderConfig);
			});
		},
	};

	sliderFeatured.init();

});
